<template>
    <div class="FeedbackNpsScale w-full">
        <div class="flex flex-row flex-wrap justify-center gap-1 sm:flex-nowrap sm:gap-1.5">
            <button
                v-for="score in npsScores"
                :key="score"
                class="flex h-10 w-9 shrink-0 items-center justify-center rounded-md text-base font-semibold text-white transition-all duration-150 hover:scale-110 sm:h-11 sm:w-10"
                :class="[scoreColorClass(score), score === modelValue ? 'ring-2 ring-gray-900 ring-offset-2 dark:ring-white dark:ring-offset-gray-800' : 'opacity-90 hover:opacity-100']"
                type="button"
                :aria-label="`${score}`"
                :aria-pressed="score === modelValue"
                @click="select(score)"
            >
                {{ score }}
            </button>
        </div>

        <div class="mt-2 flex flex-row justify-between text-xs text-gray-600 dark:text-txt-body">
            <span>Málo pravdepodobné</span>
            <span>Veľmi pravdepodobné</span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { npsScores } from '#shared/types/Feedback'

defineProps<{
    modelValue?: number
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void
    (e: 'select', value: number): void
}>()

// Same red -> orange -> yellow -> green ramp as the Bloomreach NPS e-mails
const SCORE_COLORS: Record<number, string> = {
    0: 'bg-[#d64545]',
    1: 'bg-[#e14b4b]',
    2: 'bg-[#e8603c]',
    3: 'bg-[#ec6f33]',
    4: 'bg-[#ef8a2b]',
    5: 'bg-[#f0a12a]',
    6: 'bg-[#e8b52f]',
    7: 'bg-[#e5cd3d]',
    8: 'bg-[#d7d43f]',
    9: 'bg-[#8cc63f]',
    10: 'bg-[#4caf50]'
}

function scoreColorClass(score: number): string {
    return SCORE_COLORS[score] ?? 'bg-gray-400 dark:bg-subtle'
}

function select(score: number) {
    emit('update:modelValue', score)
    emit('select', score)
}
</script>
